import React from "react";

export default function MatkaFooter({ onSelectTab, onBackToMarkets }) {
  return (
    <footer className="matka-footer-section">
      <div className="container-fluid custom-padding">
        <div className="row justify-content-between align-items-start gy-4">
          {/* Left: Matka Brand & Description */}
          <div className="col-lg-5 col-md-12">
            <h2 className="matka-footer-brand">Matka</h2>
            <p className="matka-footer-desc">
              Experience safe and secure online Matka gaming with instant results,
              24/7 withdrawals, and multiple game formats. Enjoy fair play guidelines
              and dedicated assistance.
            </p>
          </div>

          {/* Right: Games & Support Columns */}
          <div className="col-lg-6 col-md-12">
            <div className="row justify-content-lg-end gx-4 gy-3">
              <div className="col-6 col-sm-5 col-lg-5">
                <h4 className="matka-footer-col-title">Games</h4>
                <ul className="matka-footer-links-list">
                  <li
                    onClick={() => {
                      if (onBackToMarkets) onBackToMarkets();
                      if (onSelectTab) onSelectTab("Starline");
                    }}
                  >
                    Starline Games
                  </li>
                  <li
                    onClick={() => {
                      if (onBackToMarkets) onBackToMarkets();
                      if (onSelectTab) onSelectTab("Market");
                    }}
                  >
                    Regular Markets
                  </li>
                  <li
                    onClick={() => {
                      if (onBackToMarkets) onBackToMarkets();
                      if (onSelectTab) onSelectTab("Jackpot");
                    }}
                  >
                    Jackpot Arena
                  </li>
                </ul>
              </div>

              <div className="col-6 col-sm-5 col-lg-5">
                <h4 className="matka-footer-col-title">Support</h4>
                <ul className="matka-footer-links-list">
                  <li>Live Chat 24/7</li>
                  <li>FAQs</li>
                  <li>
                    <a
                      href="/terms"
                      style={{ color: "inherit", textDecoration: "none" }}
                    >
                      Terms of Service
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="matka-footer-divider" />

        {/* Bottom Row */}
        <div className="matka-footer-bottom d-flex flex-column flex-sm-row justify-content-between align-items-center">
          <p className="matka-footer-copyright mb-2 mb-sm-0">
            © 2026 Matka Gaming Platform. All rights reserved. Play responsibly.
          </p>
          <div className="matka-footer-social-links d-flex align-items-center gap-4">
            <span className="matka-footer-social-link">Telegram</span>
            <span className="matka-footer-social-link">WhatsApp</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
